module.exports = __webpack_public_path__ + "img/logo-rl.e1b1015f.jpg";